<!-- =========================================================================================
    File Name: Todo.vue
    Description: Todo Application to keep you ahead of time
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

                <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
                    
                    <VuePerfectScrollbar class="todo-scroll-area" :settings="settings" :key="$vs.rtl">
                    <todo-filters @closeSidebar="toggleTodoSidebar"></todo-filters>
                    </VuePerfectScrollbar>
                    
                </vs-sidebar>
                
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
                    
                       <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
                        <!-- TOGGLE SIDEBAR BUTTON 
                        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleTodoSidebar(true)" />
                         -->
                        <!-- SEARCH BAR -->
                        
                        </div>  
                            
                      

                     
                   

                    <!-- TODO LIST -->
                    <VuePerfectScrollbar class="todo-content-scroll-area" :settings="settings" ref="taskListPS" :key="$vs.rtl">
      
      <template>
      <vs-table search  max-items="5" pagination :data="candidat">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- Reset -->
          <div class="ml-5" >
              <vs-button type="line" line-origin="right" @click="reset" >Réinitialiser</vs-button>
   
          </div>
          

          <!-- save -->
          <div class="ml-5" >
                 <vs-button type="line" line-origin="left" color="warning" @click="save">Sauvegarder</vs-button>
  
          </div>
        </div>

       
      </div>
      <template slot="thead">
      <vs-th>nom & prénom</vs-th>
      <vs-th>présence</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :state="tr.presance == 1  ? 'success':tr.presance == 2 ? 'danger':tr.presance == 3 ? 'warning':null" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].email">
          <div class="con-userx flex items-center justify-start">
                  <vs-avatar  size="35px" :src="tr.avatar" />
                  <span>{{ data[indextr].nom +' '+data[indextr].prenom}}</span>
                </div>
          
        </vs-td>
        
        <vs-td :data="data[indextr].id">
          <!-- <vs-checkbox v-model="tr.presance" color="success" class="w-8 vs-checkbox-small " @click.stop /> -->
          <div class="mt-2">
          <span v-if="tr.presance==1 ">présent</span>
          <span v-if="tr.presance==3 ">absent justifier</span>
          <span v-if="tr.presance==2 ">absent</span>
          <vs-radio v-if="tr.presance==0" v-model="tr.presance" color="danger" vs-value="2" class="mr-4">absent</vs-radio>
          <vs-radio v-if="tr.presance==0" v-model="tr.presance" color="warning" vs-value="3" class="mr-4">absent justifier</vs-radio>
          <vs-radio v-if="tr.presance==0" v-model="tr.presance" color="success" vs-value="1" >présent</vs-radio>
          </div>
        </vs-td>
       <!-- <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              <div class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start">
                  <vs-avatar  size="45px" :src="tr.avatar" />
                  <span><vs-list-item icon-pack="feather" icon="icon-mail" :title="tr.email"></vs-list-item></span>
                  
                </div>
                
                
                <div class="flex">
                  <vs-list-item icon-pack="feather" icon="icon-phone" :title="tr.mobile"></vs-list-item>
                </div>
                
              </div>
              <div class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start">
                  <span></span>
                                 

                </div>
                
                
              </div>
              
              
            </div>
          </template> -->
      </vs-tr>
    </template>
    </vs-table>
    </template>
                    </VuePerfectScrollbar>
                    <!-- /TODO LIST -->
      </div>

                <!-- EDIT TODO DIALOG -->
                <!--todo-edit :displayPrompt="displayPrompt" :taskId="taskIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></todo-edit-->
    </div>
</template>

<script>
import moduleTodo          from '@/store/todo/moduleTodo.js'
import TodoAddNew          from "./TodoAddNew.vue"
import TodoTask            from "./TodoTask.vue"
import TodoFilters         from "./TodoFilters.vue"
import TodoEdit            from "./TodoEdit.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleseance from '@/store/seance/moduleseance.js'

export default {
  data() {
    return {
      seance:[],
      currFilter           : "",
      clickNotClose        : true,
      displayPrompt        : false,
      taskIdToEdit         : 0,
      isSidebarActive      : true,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
    }
  },
  watch: {
    
    todoFilter() {
      this.$refs.taskListPS.$el.scrollTop = 0
      this.toggleTodoSidebar()

      // Fetch Tasks
      let filter = this.$route.params.seanceId
      console.log('1',filter)
      this.$store.dispatch("seance/fetchParticipation_candidat_seance_id",this.$route.params.seanceId).catch(err => { console.error(err) })
       
      //this.$store.dispatch("todo/fetchTasks", { filter: filter })
      //this.$store.commit("todo/UPDATE_TODO_FILTER", filter)
    },
    windowWidth() {
      this.setSidebarWidth()
    },
  },
  computed: {
    isCompleted: {
          get () {
              //return this.taskLocal.isCompleted
          },
          set (value) {
            /*this.$store.dispatch("todo/updateTask", Object.assign({}, this.taskLocal, {isCompleted: value}))
              .then((response) => {
                this.taskLocal.isCompleted = response.data.isCompleted
              })
              .catch((error) => { console.error(error) })*/
            
            console.log(value)
          },},
    candidat()    { this.seance = this.$store.state.seance.participation_candidat_seance 
                   console.log('this.seance',this.seance)
                   return     this.seance        },
    todo()        { return this.$store.state.todo.todoArray              },
    todoFilter()  { return this.$route.params.seanceId                     },
    taskList()    { return this.$store.getters["todo/queriedTasks"]      },
    searchQuery:  {
      get()       { return this.$store.state.todo.todoSearchQuery        },
      set(val)    { this.$store.dispatch('todo/setTodoSearchQuery', val) }
    },
    windowWidth() { return this.$store.state.windowWidth }
  },
  methods: {
    reset(){
     this.$store.dispatch("seance/fetchParticipation_candidat_seance_id",this.$route.params.seanceId).catch(err => { console.error(err) })

    this.candidat()
    },
    save(){
      let obj=[];
      for(obj of this.seance ){
        console.log(obj)
    this.$store.dispatch("seance/updateParticipation_candidat_seance", obj)  
    
    }
    //this.$store.dispatch("seance/fetchParticipation_candidat_seance_id",this.$route.params.filter).catch(err => { console.error(err) })
    this.showMessage('success', 'mise à jour', 'mise à jour réussie')
    console.log('2',this.this.$route.params.seanceId)
    this.$store.dispatch("seance/fetchParticipation_candidat_seance_id",this.$route.params.seanceId).catch(err => { console.error(err) })

    console.log(this.seance)
    this.candidat()
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Présence '+title,
                text: 'Présence : '+text
              })
            },
    showDisplayPrompt(itemId) {
      this.taskIdToEdit  = itemId
      this.displayPrompt = true
    },
    hidePrompt() {
      this.displayPrompt = false
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false
      } else {
        this.isSidebarActive = this.clickNotClose = true
      }
    },
    toggleTodoSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarActive = value
    },
  },
  components: {
    //TodoAddNew,
    //TodoTask,
    TodoFilters,
    //TodoEdit,
    VuePerfectScrollbar
  },
  created() {
    //candidat
    let filter = this.$route.params.seanceId
    console.log('3',filter)
    if(!moduleseance.isRegistered) {
      this.$store.registerModule('seance', moduleseance)
      moduleseance.isRegistered = true
    }
    this.$store.dispatch("seance/fetchParticipation_candidat_seance_id",this.$route.params.seanceId).catch(err => { console.error(err) })
    console.log('1200',this.$store.state.seance.participation_candidat_seance)
    //
    this.$store.registerModule('todo', moduleTodo)
    this.setSidebarWidth()

    
    // Fetch Tasks
    this.$store.dispatch("todo/fetchTasks", { filter: filter })
    this.$store.commit("todo/UPDATE_TODO_FILTER", filter)

    // Fetch Tags
    this.$store.dispatch("todo/fetchTags")
  },
  beforeUpdate() {
    this.currFilter = this.$route.params.seanceId
  },
  beforeDestroy: function() {
    this.$store.unregisterModule('todo')
  },
  mounted() {
    this.$store.dispatch("todo/setTodoSearchQuery", "")
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
</style>
